import client from './client';

export const authApi = {
  signup: (data) => client.post('/auth/signup/', data).then((r) => r.data),
  login: (data) => client.post('/auth/login/', data).then((r) => r.data),
  logout: () => client.post('/auth/logout/'),
  me: () => client.get('/auth/me/').then((r) => r.data),
  requestPasswordReset: (email) => client.post('/auth/password-reset/request/', { email }),
  confirmPasswordReset: (data) => client.post('/auth/password-reset/confirm/', data),
  requestEmailVerify: () => client.post('/auth/email/verify/request/'),
  confirmEmailVerify: (data) => client.post('/auth/email/verify/confirm/', data).then((r) => r.data),
};
